import { render, staticRenderFns } from "./LessonsRatingEnglish.vue?vue&type=template&id=38ca43dc"
import script from "./LessonsRatingEnglish.vue?vue&type=script&lang=js"
export * from "./LessonsRatingEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports